import { ApiClient } from './ApiClient';
import events from './events';
const apiClient = new ApiClient('/api/favorites');
export function addOrRemoveFavorite() {
    async function add(sku) {
        await apiClient.post('/add', { sku });
    }
    async function remove(sku) {
        await apiClient.post('/remove', { sku });
    }
    return {
        sku: '',
        error: { message: '', status },
        isLoading: false,
        isFavorite: false,
        $el: {},
        init() {
            const product = JSON.parse(this.$el.closest('[data-product]').dataset.product);
            this.sku = product.sku;
            this.isFavorite = product.isFavorite;
        },
        toggleFavorite(_, loginUrl) {
            this.isLoading = true;
            const operation = !this.isFavorite ? add(this.sku) : remove(this.sku);
            operation.then(() => {
                this.isFavorite = !this.isFavorite;
            }).catch(err => {
                if (err.status === 401) {
                    if (!loginUrl) {
                        events.openLogin.trigger({ open: true, centeredFixed: true });
                    }
                    else {
                        location.href = loginUrl;
                    }
                }
            }).finally(() => this.isLoading = false);
        },
    };
}
